/*
 * Name : YesNoToggleButton.
 * Props : we are using value, onchange, id as props.
 * Description : Material-ui ToggleButtons are used for implementing yes or no buttons.
 */

import React, { useState } from 'react';
import ToggleButton from '@material-ui/lab/ToggleButton';
import ToggleButtonGroup from '@material-ui/lab/ToggleButtonGroup';
import './yesno.scss';

type ToggleButtonProps = {
    value: string,
    onChange: (val: string) => void,
    id: string,
    updateValueDisabled: boolean
}

const YesNoToggleButton = (props: ToggleButtonProps) => {
    const { value, onChange, id, updateValueDisabled } = props;
    const [alignment, setAlignment] = useState(value);

    const handleAlignment = (event, newAlignment) => {
        setAlignment(newAlignment);
        onChange(newAlignment);
    };

    return (
        <div className="yesorno-btn" data-testid="yesorno">
            <div
                className={`two-togglebtn-${id} toggleYesNoBtn`}
                id={`two-togglebtn-${id}`}
            >
                <ToggleButtonGroup
                    value={alignment}
                    exclusive
                >
                    <span> &nbsp; </span>
                    <ToggleButton
                        value="2"
                        aria-label="yes"
                        id={`yes-btn-${id}`}
                        onClick={(e) => { handleAlignment(e, (2).toString()); }}
                        disabled={updateValueDisabled}
                    >
                        Yes
                    </ToggleButton>
                    <ToggleButton
                        value="1"
                        aria-label="no"
                        id={`no-btn-${id}`}
                        onClick={(e) => { handleAlignment(e, (1).toString()); }}
                        disabled={updateValueDisabled}
                    >
                        No
                    </ToggleButton>
                </ToggleButtonGroup>
            </div>
        </div>
    )
}

export default YesNoToggleButton;
